

export const FILE_NAME = 'invoice_information';
export const TITLE = 'INVOICE INFORMATION';

export const TABLE_COLUMNS = [
  {
    Header: 'Origin IMPC',
    accessor: 'originImpcCode',
    width: 400,
  },
  {
    Header: 'Dest IMPC',
    accessor: 'destinationImpcCode',
    width: 400,
  },
  {
    Header: 'Weight of Receptacles (kgs)',
    accessor: 'receptaclesWeight',
    type: 'number',
    width: 400,
  },
  {
    Header: 'Count of Receptacles',
    accessor: 'receptaclesNumber',
    type: 'number',
    width: 400,
  },
  200,
];

export const COLUMNS = [
  {
    header: 'Origin IMPC',
    key: 'originImpcCode',
    width: 80,
  },
  {
    header: 'Dest IMPC',
    key: 'destinationImpcCode',
    width: 80,
  },
  {
    header: 'Weight of Receptacles (kgs)',
    key: 'receptaclesWeight',
    width: 80,
  },
  {
    header: 'Count of Receptacles',
    key: 'receptaclesNumber',
    width: 80,
  },
];
